import { useQuery } from "@tanstack/react-query";
import api from "../../http";

export const useGetFertilizerById = (id: string, enabled = true) => {
    return useQuery({
        queryKey: ['fertilizer', id],
        queryFn: async () => (await api.get(`/products/fertilizer/get/${id}`)).data,
        enabled: !!id && enabled,
    });
};